<template>
  <div
    id="app"
    :class="login ? (public1 ? 1 : 'loginBg') : ''"
    :style="!$route.meta.paddingBottom ? 'padding-bottom: 355px;' : ' '"
    v-loading="loading"
    element-loading-text="正在加载中"
    customClass="custom"
    element-loading-spinner="el-icon-loading"
    @mouseover="isDon"
  >
    <topBar
      v-if="!$route.meta.hideHead && isShowPage && !dialogVisible"
    ></topBar>
    <router-view v-if="isShowPage && callbackUrl && !dialogVisible" />
    <router-view v-if="!callbackUrl && !dialogVisible && hasToken" />
    <footerBar
      v-if="!$route.meta.hideHead && isShowPage && !dialogVisible"
    ></footerBar>

    <el-dialog
      title="平台推荐浏览器及版本号"
      :visible.sync="dialogVisible"
      width="40%"
      :close-on-click-modal="false"
      :show-close="false"
    >
      <p>敬爱的用户：</p>
      <p>
        您好！为了更好的用户体验，平台推荐使用新版的Chrome、Firefox等浏览器。系统识别到您当前使用
        的浏览器不在平台推荐浏览器及版本号范围内，为避免页面跳转缓慢或加载不出来等问题，建议您切换使
        用的浏览器。平台推荐的浏览器及版本号，详见下表:
      </p>
      <p>平台推荐的浏览器及版本号：</p>
      <div
        style="
          width: 100%;
          height: 100px;
          margin-top: 15px;
          margin-bottom: 15px;
        "
      >
        <img
          style="
            width: 85%;
            height: 100px;
            text-align: center;
            margin: 0 auto;
            display: block;
          "
          src="../src/assets/img/browser_table_v2.png"
          alt=""
        />
      </div>
      <p>平台推荐的浏览器图标：</p>
      <div class="imgBox" style="margin-top: 15px; margin-bottom: 15px">
        <div
          v-for="(item, index) in browser"
          :key="index"
          @click="gotoDown(item.url)"
        >
          <div style="width: 110px; height: 70px">
            <img
              style="
                width: 64px;
                height: 64px;
                text-align: center;
                margin: 0 auto;
                display: block;
              "
              :src="item.img"
              alt=""
            />
          </div>
          <span class="imgBoxSpan">{{ item.name }}</span>
        </div>
      </div>
      <p style="text-align: center">点击图标下载浏览器</p>
    </el-dialog>
    <!-- <div v-if="loading1" style="height:100%;position: fixed;top:0px;width:1920px;z-index:999;background-color: rgba(255,255,255,0.9);"     v-loading="loading1"
    element-loading-text="正在加载中"
    customClass="custom"
    element-loading-spinner="el-icon-loading">
    </div> -->
  </div>
</template>

<script>
import topBar from "@/components/header/index.vue";
import footerBar from "@/components/footer/index.vue";
import mobileHeader from "@/components/mobileComponents/header.vue";
import mobileFooter from "@/components/mobileComponents/footer.vue";
import { Get, Post } from "@/api/axios";
import axios from "axios";
import store from "../src/store/store.js";
import { Mixins } from "./api/mixins";
import { MessageBox, Message, Form } from "element-ui";
import { claim } from "@/api/claim.js";
export default {
  components: { topBar, footerBar, mobileHeader, mobileFooter },
  name: "App",
  data() {
    return {
      hasToken: false,
      login: true,
      public1: false,
      isShowPage: false,
      callbackUrl: false,
      loading: false,
      loading1: true,
      ind: 0,
      timer: "",
      timer1: "",
      dialogVisible: false,
      nowNav: "",
      browser: [
        {
          name: "Edge浏览器",
          url: "https://www.microsoft.com/zh-cn/edge",
          img: require("../src/assets/img/Edge.png")
        },
        {
          name: "Firefox浏览器",
          url: "http://www.firefox.com.cn/",
          img: require("../src/assets/img/firefox.png")
        },
        {
          name: "Chrome浏览器",
          url: "https://www.google.cn/chrome/",
          img: require("../src/assets/img/chrome.png")
        },
        {
          name: "360安全浏览器(极速)",
          url: "https://browser.360.cn/se/",
          img: require("../src/assets/img/360.jpg")
        },
        {
          name: "QQ浏览器",
          url: "https://browser.qq.com/",
          img: require("../src/assets/img/qq.jpg")
        }
      ]
    };
  },
  mixins: [Mixins],
  created() {
    window.version = "v1";
    sessionStorage.removeItem("keyStatic");
    sessionStorage.removeItem("keywordChange");
    if (location.href.indexOf("bindThLogin") == -1) {
        // 接口版本号
        this.getToken();
      } else {
        this.hasToken = true
        let url = location.href;
        let paramsarr = url.split("?")[1];
        let b = paramsarr.split("&");
        let arr = {};
        b.forEach((el, i) => {
          arr[el.split("=")[0]] = el.split("=")[1];
        });
        localStorage.setItem("loginProviderId", arr.loginProviderId);
        this.$router.push({
          path: "/thirdLogin",
          query: {
            code: arr.code,
            loginProviderId: arr.loginProviderId
          }
        });
      }
  },
  mounted() {
    console.log('父级mounted')
    this.$nextTick(() => {
      // console.log(location.href,'location.href---App');
      // 如果有bindThLogin，说明为第三方登录绑定，如果没有在判断是不是 个人中心的绑定第三方。

      if (location.href.indexOf("jsessionid") != -1) {
        let b = location.href.indexOf("&jsessionid=");
        let jsessionid = location.href.substring(b + 12, location.href.length);
        document.cookie = "JSESSIONID =" + jsessionid;
      }

      if (location.href.indexOf("uuid") != -1) {
        let a = location.href.indexOf("uuid=") + 5;
        let b = location.href.indexOf("&jsessionid=");
        let urls = location.href.substring(a, b);
        localStorage.setItem("uuid", urls);
      }
      localStorage.setItem("ExitSta", false);
      // 采编同步登录跳转
      if (
        location.href.indexOf("uuid") != -1 &&
        location.href.indexOf("jsessionid") != -1 &&
        location.href.indexOf("nowNav") != -1
      ) {
        //  let c = location.href.indexOf("&nowNav=");
        //  let nowNav = location.href.substring(c + 8, location.href.length);
        this.$router.push({
          path: "/personal"
        });
      }
      // 跳转个人信息Tab
      if (
        location.href.indexOf("jumpType") != -1 ||
        location.href.indexOf("jumpName") != -1
      ) {
        let url = location.href;
        console.log(url, "跳转个人信息Tab");
        console.log(document.referrer, "document.referrer");
        let paramsarr = url.split("?")[1];
        let b = paramsarr.split("&");
        let arr = {};
        if (
          document.referrer.indexOf("medpress.yiigle.com") != -1 ||
          document.referrer.indexOf("yxh.testx.fzyun.io") != -1
        ) {
          console.log('设置');
          localStorage.setItem("TabUrl", url);
        } else {
          console.log('清空');
          localStorage.removeItem("TabUrl");
        }

        b.forEach((el, i) => {
          arr[el.split("=")[0]] = el.split("=")[1];
        });
        this.$router.push({
          path: "/personal",
          query: {
            nowNav: "basicInfo",
            jumpType: arr.jumpType,
            jumpName: arr.jumpName,
            activeMenu: arr.activeMenu
          }
        });
      }
    });
    this.judge();
    console.log(
      window.location.protocol + "//" + window.location.host,
      "1233333"
    );
  },
  methods: {
    // 获取最后一次实名认证的真实姓名
    getLatestDetail() {
      let params = {
        id: window.localStorage.getItem("memberId") || this.memberInfo.userId,
        isMain: 1
      };
      claim.getLatestDetail(params).then(res => {
        if (res && res.data) {
          console.log(res.data, '获取最后一次实名认证的真实姓名');
          this.$store.commit('updateState', {
            key: 'latestDetail',
            value: res.data
          })
        }
      });
    },
    gotoDown(url) {
      console.log(url, "url");
      window.open(url);
    },
    isDon() {
      window.localStorage.setItem("lastTime", new Date().getTime());
      console.log();
    },
    getToken() {
      let id = "";
      axios({
        url:
          "/baas-platform/" +
          window.version +
          "/platform/usercenter/appauthtoken",
        method: "get"
      }).then(res => {
        // console.log(res,'appauthtoken---res');
        id = res.data.data;
        window.sessionStorage.setItem("token", res.data.data);
        this.hasToken = true;
        // 获取公钥
        // if (location.href.indexOf("personal") != -1) {
        axios({
          url: "/member/spc/" + window.version + "/getPublishKey",
          method: "post",
          headers: {
            authToken: id
          }
        }).then(res => {
          if (res.data.status == 0) {
            if (typeof res.data.data == "string") {
              localStorage.setItem("gy", res.data.data);
            }
          }
        });
        this.getCasConfig();
        this.getExitTime();
      }).finally(() => {
        this.hasToken = true;
      });
    },
    // 获取后台配置的各个地址
    getCasConfig() {
      let cookieUUID = this.getCookie("uuid");
      console.log(cookieUUID, "cookieUUID");
      if (
        location.href.indexOf("/thirdLogin") == -1 &&
        location.href.indexOf("bindThLogin") == -1
      ) {
        let url = "/member/spc/v1/allMemberInfo/getCasConfig.do";
        Get(url).then(res => {
          localStorage.setItem("casLogin", res.data.casLogin);
          localStorage.setItem("casLogout", res.data.casLogout);
          localStorage.setItem("journalDbUrl", res.data.journalDbUrl);
          localStorage.setItem("journalUrl", res.data.journalUrl);
          localStorage.setItem(
            "clientIndexUrl",
            res.data.clientIndexUrl || "https://ucenter.yiigle.com"
          );
          this.$casLoginUrl = res.data.clientIndexUrl;
          this.$journalDb = res.data.journalDb;
          console.log(this.$journalDb, "Vue.prototype.$journalDb");
          console.log(
            location.href.indexOf("uuid"),
            "获取后台配置时是否有uuid"
          );
          console.log(
            localStorage.getItem("memberId"),
            "获取后台配置时是否有memberId"
          );

          setTimeout(() => {
            if (
              this.$route.path !== "/reg" &&
              this.$route.path !== "/getPass" &&
              this.$route.path !== "/thirdLogin" &&
              location.href.indexOf("loginProviderId") == -1
            ) {
              if (this.$route.path == "/personal") {
                if (
                  location.href.indexOf("basicInfo") == -1 &&
                  location.href.indexOf("ticket") == -1
                ) {
                  this.goSm();
                }
              }
            }
            if (location.href.indexOf("uuid") != -1 || cookieUUID) {
              console.log("cookie获取uuid调userID");
              this.getuserId(cookieUUID);
            } else {
              // this.isShowPage = true;
              //   if (location.href.indexOf("signOutSuccess") !== -1) {
              //   this.isShowPage = false
              //   console.log(this.isShowPage,'this.isShowPage');
              //   return;
              // }
              if (window.localStorage.getItem("memberId")) {
                if (
                  this.$route.path == "/reg" ||
                  this.$route.path == "/getPass"
                ) {
                } else {
                  this.getDetail();
                }
                this.getuserType();
              }
            }

            // 解决从机构跳转过来的时候登录不上的问题
            // 如果不是第三方登录页并且  如果没有 UUID 并且没有用户ID的时候刷新
            if (
              location.href.indexOf("bindThLogin") == -1 &&
              location.href.indexOf("reg") == -1 &&
              location.href.indexOf("getPass") == -1 &&
              location.href.indexOf("payment") == -1 &&
              location.href.indexOf("wechatPay") == -1 &&
              location.href.indexOf("qkLogin") == -1 &&
              location.href.indexOf("PaymentSuccess") == -1 &&
              location.href.indexOf("preRegistration") == -1 &&
              location.href.indexOf("LoginSignOUT") == -1 &&
              location.href.indexOf("signOutSuccess") == -1 &&
              location.href.indexOf("offprint") == -1
            ) {
              if (
                location.href.indexOf("uuid") == -1 &&
                !localStorage.getItem("memberId") &&
                !cookieUUID
              ) {
                console.log("进入刷新");
                let locals = "";

                if (location.href.indexOf("/offprint") !== -1) {
                  locals =
                    window.location.protocol +
                    "//" +
                    window.location.host +
                    location.href.substring(location.href.indexOf("/offprint"));
                } else {
                  locals =
                    window.location.protocol +
                    "//" +
                    window.location.host +
                    "/personal?nowNav=home";
                }

                let codes =
                  window.location.protocol +
                  "//" +
                  window.location.host +
                  "/member/cas/auth?redirectUrl=" +
                  locals;

                console.log(locals, "localslocalslocals");
                console.log(res.data.casLogin + "?service=" + codes);
                location.href = res.data.casLogin + "?service=" + codes;
              }
            }
            // 解决从机构跳转过来的时候登录不上的问题end
          }, 500);
        });
      } else {
        this.isShowPage = true;
        // 第三方登录不需要这些
      }
    },
    // 获取cookie中的 uuid
    getCookie(cname) {
      console.log("获取cookie中的 uuid");
      var name = cname + "=";
      var ca = document.cookie.split(";");
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i].trim();
        if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
      }
      return "";
    },
    // 获取用户类型，345在个人中心  12去机构地址
    getuserType() {
      let params = {
        userId: localStorage.getItem("memberId")
      };
      let url = "/member/spc/v1/member/getUserType";
      Get(url, params).then(res => {
        // alert(localStorage.getItem("memberId"))
        // alert(res.data.userType)
        if (res.data.userType != null) {
          if (res.data.userType == 1 || res.data.userType == 2) {
            localStorage.removeItem("addLoginNameId");
            localStorage.removeItem("time");
            localStorage.removeItem("memberId");
            localStorage.removeItem("addLoginName");
            localStorage.removeItem("loginName");
            localStorage.removeItem("gy");
            localStorage.removeItem("uuid");
            sessionStorage.clear();
            localStorage.setItem("isLogout", "true");
            window.location = localStorage.getItem("journalDbUrl");
          }
        }
      });
    },
    getUrlParam(name) {
      //构造一个含有目标参数的正则表达式对象
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)"); //匹配目标参数
      var r = window.location.search.substr(1).match(reg); //返回参数
      if (r != null) {
        return unescape(r[2]);
      } else {
        return null;
      }
    },
    async getuserId(cookieUUID) {
      // let a = location.href.indexOf("uuid=") + 5;
      // let urls = location.href.substring(a, b);
      let urls = cookieUUID || this.getUrlParam("uuid");
      let data = [];
      // let b = location.href.indexOf("&jsessionid=");

      let params = {
        logintoken: urls
      };
      await Post("/member/index/getUserInfo", params, "isJson")
        .then(res => {
          data = res.data;
          console.log(data, "getUserInfo数据");
          if (data && data.userId) {
            localStorage.setItem("memberId", data.userId);
            localStorage.setItem("userToken", data.token);
            this.$store.commit("updateState", {
              key: "memberId",
              value: data.userId
            });
            this.callbackUrl = true;
            this.isShowPage = true;
            // if (location.href.indexOf("signOutSuccess") !== -1) {
            //   this.isShowPage = false
            //   console.log(this.isShowPage,'this.isShowPage');
            //   return;
            // }
            // if (window.location.href.indexOf("uuid") > -1) {
            //   this.$router.push({ path: "/personal?nowNav=home" });
            // }
            this.getuserType();
            this.getDetail(data.userId);
          } else {
            if (location.href.indexOf("getPass") !== -1) {
              return;
            }
            if (location.href.indexOf("reg") !== -1) {
              return;
            }
            if (location.href.indexOf("payment") !== -1) {
              return;
            }
            if (location.href.indexOf("PaymentSuccess") !== -1) {
              return;
            }

            if (location.href.indexOf("preRegistration") !== -1) {
              return;
            }
            if (location.href.indexOf("LoginSignOUT") !== -1) {
              return;
            }
            if (location.href.indexOf("offprint") !== -1) {
              return;
            }
            console.log(
              location.href.indexOf("signOutSuccess") !== -1,
              'location.href.indexOf("signOutSuccess") !== -1'
            );
            if (location.href.indexOf("signOutSuccess") !== -1) {
              // this.isShowPage = false
              console.log(this.isShowPage, "this.isShowPage");
              return;
            }
            let url = encodeURIComponent(location.href);
            console.log(url, "app -url--Post");
            let codes =
              window.location.protocol +
              "//" +
              window.location.host +
              "/member/cas/auth?redirectUrl=" +
              url;
            console.log(codes, "codes--Post");
            console.log(
              localStorage.getItem("casLogin") +
                "?service=" +
                encodeURIComponent(codes),
              "跳转的地址 app--Post"
            );
            location.href =
              localStorage.getItem("casLogin") +
              "?service=" +
              encodeURIComponent(codes);
            store.commit("clearCancelToken");
            localStorage.removeItem("addLoginNameId");
            localStorage.removeItem("time");
            localStorage.removeItem("memberId");
            localStorage.removeItem("addLoginName");
            localStorage.removeItem("loginName");
            localStorage.removeItem("gy");
            localStorage.removeItem("uuid");
            sessionStorage.clear();

            // 本地调试时 获取不到memberID时 运行

            // localStorage.setItem("memberId", "1520070");
            // this.$store.commit("updateState", {
            //   key: "memberId",
            //   value: "1520070"
            // });
            // this.callbackUrl = true;
            // this.isShowPage = true;
            // this.getuserType();
            // this.getDetail(data);
          }
        })
        .catch(err => {});
    },
    getDetail(data) {
      // loginProviderId 用于获取第三方用户信息的id
      if (localStorage.getItem("loginProviderId")) {
        localStorage.removeItem("loginProviderId");
        // return false;
      }
      let id = data || localStorage.getItem("memberId");
      this.getLatestDetail(); // 获取最后一次实名认证的真实姓名
      Post("/member/spc/v1/allMemberInfo/getMemberDetail.do?userId=" + id).then(
        res => {
          if (res.status == 0) {
            let data = res.data.content[0];
            window.localStorage.setItem(
              "getMemberDetail",
              JSON.stringify(data)
            );
            if (res.data.content[0].bassMember) {
              window.localStorage.setItem(
                "loginName",
                res.data.content[0].bassMember.nickName ||
                  res.data.content[0].bassMember.loginName
              );
              if (
                res.data.content[0].bassMember.loginName &&
                res.data.content[0].bassMember.loginName != null &&
                res.data.content[0].bassMember.loginName != "null"
              ) {
                window.localStorage.setItem(
                  "addLoginName",
                  res.data.content[0].bassMember.loginName
                );
              } else {
                window.localStorage.removeItem("addLoginName");
              }

              window.localStorage.setItem(
                "addLoginNameId",
                res.data.content[0].bassMember.id
              );
            }

            let arr = ["memberInfo", "bassMember"];
            arr.forEach(item => {
              if (data[item] != null) {
                this.$store.commit("updateState", {
                  key: item,
                  value: { ...data[item] }
                });
              }
            });
            if (data.memberVocationInfos) {
              this.$store.commit("updateState", {
                key: "memberVocationInfos",
                value: { ...data["memberVocationInfos"] }
              });
            }
            if (data.expertLabel != null) {
              this.$store.commit("updateState", {
                key: "zjList",
                value:
                  data.expertLabel != "" ? JSON.parse(data.expertLabel) : []
              });
            }
          }
        }
      );
    },
    cleart() {
      var keys = document.cookie.match(/[^ =;]+(?=\=)/g);
      if (keys) {
        for (var i = keys.length; i--; )
          document.cookie = keys[i] + "=0;expires=" + new Date(0).toUTCString();
      }
    },
    getExitTime() {
      if (location.href.indexOf("signOutSuccess") !== -1) {
        return;
      }

      Get("/member/spc/" + window.version + "/getConfig?key=LOGIN_RULES").then(
        res => {
          let data = res.data[0];
          let interval = null;
          if (data.value) {
            let timerNum = 0;
            let timerData = JSON.parse(data.value);
            let num = timerData["timedExit"].value;
            let unit = timerData["timedExitunit"].value;
            if (unit == "分钟") {
              timerNum = num * 60;
            } else if (unit == "小时") {
              timerNum = num * 60 * 60;
            } else if (unit == "天") {
              timerNum = num * 60 * 60 * 24;
            }
            interval = timerNum;
            window.localStorage.setItem("timer", timerNum);
          } else {
            interval = null;
            // this.$message.error(res.data.message);
          }
          let time = new Date().getTime();

          window.localStorage.setItem("tokenTime", time);
          if (localStorage.getItem("lastTime")) {
            setTimeout(() => {
              let a = setInterval(() => {
                if (
                  new Date().getTime() - localStorage.getItem("lastTime") >
                  interval * 1000
                ) {
                  console.log("到时间刷新");
                  window.localStorage.setItem("lastTime", new Date().getTime());
                  clearInterval(a);
                  location.reload();
                }
              }, 1000);
            }, 500);
          }
        }
      );
    },
    judge() {
      let flag = document.documentMode ? document.documentMode : false;
      if (flag) {
        console.log("当前IE浏览器版本号是", flag);
        // if (flag < 11) {
        this.dialogVisible = true;
        // }
      } else {
        console.log("当前浏览器可能不是IE浏览器");
      }
    },
    goSm() {
      Get(
        "/member/spc/" +
          window.version +
          "/authentication/find?type=2&orgCode=REAL_NAME" +
          "&userId=" +
          localStorage.getItem("memberId")
      ).then(res => {});
    }
  },
  watch: {
    $route(to, from) {
      console.log(to.query.nowNav, from.query.nowNav, "APP路由监听");
      this.nowNav = to.query.nowNav;
      // this.loading = true;
      //================第三方绑定跳转遮罩层
      if (location.href.indexOf("code") != -1) {
        this.loading = true;
        if (
          location.href.indexOf("thirdLogin") != -1 ||
          location.href.indexOf("wechatPay") != -1 ||
          location.href.indexOf("payment") != -1 ||
          location.href.indexOf("PersonalWechatPay") != -1
        ) {
          this.loading = false;
        }
        setTimeout(() => {
          this.loading = false;
        }, 800);
      }
      if (to.query.thirdParty == "thirdParty") {
        this.loading = false;
      }

      //================结束
      console.log(to, "app监听");
      if (
        to.name == "login" ||
        to.name == "getPass" ||
        to.name == "reg" ||
        to.name == "thirdLoginPage" ||
        to.name == "thirdLogin"
      ) {
        this.login = true;
        this.public1 = false;
        this.$store.commit("updateState", {
          key: "memberId",
          value: ""
        });
      } else if (to.name == "payment" || to.name == "wechatPay") {
        this.login = true;
        this.public1 = true;
      } else {
        this.public1 = false;
        this.login = false;
        this.$store.commit("updateState", {
          key: "memberId",
          value: window.localStorage.getItem("memberId")
        });
      }
      if (from.query.nowNav == "vipClub" || from.query.nowNav == "home") {
        store.commit("clearCancelToken");
      }
      if (to.name == "reg" || to.name == "getPass") {
        this.cleart();
      }
      // 取消未返回结果的接口
      // store.commit("clearCancelToken");
    }
  }
};
</script>
<style lang="scss">
#app {
  background: rgb(245, 247, 248);
  position: relative;
  min-height: 100%;
  .el-loading-mask {
    height: 100%;
    max-height: 1080px;
    z-index: 997;
  }
  .el-loading-spinner .el-loading-text {
    color: #52b8cc;
  }
  .el-loading-spinner i {
    color: #52b8cc;
    font-size: 30px;
  }
}
.imgBox {
  display: flex;
  justify-content: space-around;
}
.imgBoxSpan {
  width: 100%;
  margin: 0 auto;
  display: block;
  text-align: center;
}
.loginBg {
  background: url("./assets/img/new-Login_bg.jpg") no-repeat;
  width: 100%;
  height: 100%;
  min-height: 786px;
  background-size: cover;
  -webkit-background-size: cover;
  -o-background-size: cover;
  overflow: auto;
  position: absolute;
}
</style>
<style>
/* #app {
  padding-bottom: 335px;
} */
.login-bg {
  height: 100%;
  background: url("./assets/mobileImgs/bg.png") no-repeat #e9ebf7;
  background-size: 100% auto;
  -webkit-background-size: 100% auto;
}

.mobileFooter {
  display: none;
}

.mobileHeader {
  display: none;
}

.el-select-dropdown {
  z-index: 99999 !important;
}

@media screen and (min-width: 768px) and (max-width: 992px) {
  .mobileFooter {
    display: block;
  }

  .mobileHeader {
    display: block;
  }

  .loginBg {
    overflow: auto;
    height: auto;
  }

  /* #app {
    padding-bottom: 0;
  } */
}

@media screen and (max-width: 767px) {
  .mobileFooter {
    display: block;
  }

  .mobileHeader {
    display: block;
  }

  .loginBg {
    overflow: auto;
    height: auto;
  }

  /* #app {
    padding-bottom: 0;
  } */
}
</style>



// WEBPACK FOOTER //
// src/App.vue